/**
 * DEV-021 · One presentation-side date formatter shared by the five
 * visual surfaces so ISO strings (`2026-09-24`) are never rendered
 * raw to the user. Returns `24 Sep 2026` in en-GB regardless of the
 * runtime locale so the UI reads consistently in the UK-focused
 * SolarFlow deployment.
 *
 * NB — display formatting only. No timezone/aggregation changes.
 */
export function formatHumanDate(iso) {
    if (!iso) return "";
    const s = String(iso);
    // Accept both YYYY-MM-DD and full ISO timestamps.
    const short = s.length >= 10 ? s.slice(0, 10) : s;
    const parts = short.split("-").map((x) => parseInt(x, 10));
    if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return short;
    try {
        const dt = new Date(parts[0], parts[1] - 1, parts[2]);
        return dt.toLocaleDateString("en-GB", {
            day: "2-digit", month: "short", year: "numeric",
        });
    } catch { return short; }
}
